import yup from 'src/utils/yup';
import createTypedAction from '../createTypedAction';

export const PREFIX = '@@fox/dashboard/';

export const { fetchDeviceNav, FETCH_DEVICE_NAV }: any = createTypedAction(
  `${PREFIX}FETCH_DEVICE_NAV`,
  ['tab', yup.string().required()],
  ['selectedFilters', yup.immutable().map()]
);

export const { fetchDeviceNavSuccess, FETCH_DEVICE_NAV_SUCCESS }: any = createTypedAction(
  `${PREFIX}FETCH_DEVICE_NAV_SUCCESS`,
  ['nav', yup.object().required()]
);

export const { fetchDeviceNavFailed, FETCH_DEVICE_NAV_FAILED }: any = createTypedAction(
  `${PREFIX}FETCH_DEVICE_NAV_FAILED`,
  ['err', yup.object().nullable()]
);
